import { defineLocalStore } from '@/utils/localStore'
import { useRoute } from 'vue-router'
import { computed, reactive } from 'vue'
import {
  registrationJournalActivate,
  registrationJournalDeactivate,
  registrationJournalMaskDelete,
  registrationJournalSingle,
  registrationJournalUpdate,
} from '@/requests/registrationJournal'
import { setSnackbar } from 'best-modules/plugins'
import {
  RegistrationJournal,
  RegistrationJournalCredentials,
} from '@/utils/types/registrationJournal'
import { cachedObject } from 'best-modules/utils'
import { required, useVuelidate } from '@/plugins'

export const {
  initLocalStore: initRegistrationJournal,
  useLocalStore: useRegistrationJournal,
} = defineLocalStore('registrationJournal', () => {
  const route = useRoute()
  const journalId = computed<number>(() => {
    return Number(route.params.id)
  })
  const journalSource = reactive<RegistrationJournal>({} as RegistrationJournal)
  const journalCredentials = cachedObject<RegistrationJournalCredentials>({
    code: '',
    name: '',
    numberMask: '',
    docTypeDefinitionIds: [],
    departmentIds: [],
  })

  const setJournal = (obj: RegistrationJournal): void => {
    Object.assign(journalSource, obj)
    journalCredentials.$set(obj)
  }

  const rules = {
    name: { required },
    code: { required },
  }
  const v$ = useVuelidate(rules, journalCredentials)

  const getRegistrationJournalSingle = () => {
    return registrationJournalSingle(journalId.value).then(res => {
      setJournal(res)
    })
  }

  const updateJournal = () => {
    v$.value.$touch()
    if (!v$.value.$invalid) {
      return registrationJournalUpdate(
        journalId.value,
        journalCredentials.$object
      ).then(res => {
        setJournal(res)
        setSnackbar({ text: 'Дані успішно оновлені' })
      })
    }
  }

  const deleteMask = () => {
    return registrationJournalMaskDelete(journalId.value).then(res => {
      setJournal(res)
      setSnackbar({ text: 'Маску видалено' })
    })
  }

  const toggleActive = async () => {
    if (journalSource.isActive) {
      await registrationJournalDeactivate(journalId.value)
    } else {
      await registrationJournalActivate(journalId.value)
    }
    journalSource.isActive = !journalSource.isActive
  }

  getRegistrationJournalSingle()

  return {
    journalId,
    journalSource,
    journalCredentials,
    updateJournal,
    deleteMask,
    toggleActive,
    v$,
  }
})
